import React from "react";
import { Container, Form, Button, Card } from "react-bootstrap";
import Logo  from "../assets/images/logo.png";
import { RESET_PASSWORD } from "../api/constants";
import Swal from "sweetalert2";
import { useNavigate } from 'react-router-dom';

function ResetPassword() {
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [success, setSuccess] = React.useState('');
  const [token, setToken] = React.useState('');
    const navigate = useNavigate();

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenParam = urlParams.get('token');
    if (tokenParam) {
      setToken(tokenParam);
    } else {
      setError('Invalid reset link');
    }
  }, []);

  const handleResetPassword = async () => {
    if (!password || !confirmPassword) {
      setError('All fields are required');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const response = await fetch(RESET_PASSWORD, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token, password }),
      });

      const data = await response.json();
      if (data.status) {
        Swal.fire({
          icon: "success",
          title: "Password Reset",
          text: data.message || "Your password has been reset successfully.",
          confirmButtonText: "OK",
        });
        setPassword('');
        setConfirmPassword('');
        setError('');
        navigate("/sign-in");
      } else {
        setError(data.message || 'Failed to reset password');
        setSuccess('');
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
      setSuccess('');
    }
  };

  return (
    <div className="login-sign-main common-padding" >
      <Container>
        <Card>
          <div className="login-sign-wrap">
            <img src={Logo} width={160} alt="" />
            <h3 className="mb-3">Reset your password</h3>
            <p className="mt-0">Enter your new password below.</p>
          </div>

          <Form>
            <Form.Group className="from-group mb-3">
              <Form.Control type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </Form.Group>
            <Form.Group className="from-group">
              <Form.Control type="password" placeholder="Confirm new password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
            </Form.Group>
            <Button onClick={handleResetPassword} className="custom-bttn style-3 w-100 mt-3">
              Reset Password
            </Button>

                        <p className="text-danger">
              {error}
            </p>

             <p className="mb-0">
              <a href="/forgot-password">
                Back to Forgot Password
              </a>
            </p>
           
          </Form>
        </Card>
      </Container>
    </div>
  );
}

export default ResetPassword;